// extracted by mini-css-extract-plugin
export var bottom = "index-module--bottom--22T+q";
export var leftFloatingImgWrapper = "index-module--leftFloatingImgWrapper--Y+oeX";
export var rightFloatingImgWrapper = "index-module--rightFloatingImgWrapper--WASZi";
export var top = "index-module--top--4HxlP";